import { Progress } from 'src/interfaces/course';

export function addVisitedSubmodule(
  progress: Progress | null,
  submoduleId: string
): Progress | null {
  if (!progress) return progress;
  const visited = progress.visitedSubmodules || [];
  if (visited.includes(submoduleId)) return progress;
  return { ...progress, visitedSubmodules: [...visited, submoduleId] };
}
